// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_ow-5";
export var filledCircle = "_ow-4";
export var historyEntry = "_ow-3";
export var messageSideLeft = "_ow-1";
export var messageSideRight = "_ow-2";
export var orderTrackingCarouselWrapper = "_ow-6";
export var orderTrackingInfoContainer = "_ow-0";